import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'components/shared';
import {
  GridContainer,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

const ExternalSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <GridContainer>
      <GridCompact6>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.scaleExt')}
          name="scaleExt"
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.seniorityExt')}
          name="seniorityExt"
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.claExt')}
          name="claExt"
        />
      </GridCompact6>
    </GridContainer>
  );
};

export default ExternalSection;
